<template>
    <section v-if="pageLoader">
        <div class="page-loader">{{ $t("loading.loading") }}</div>
    </section>
    <section v-else-if="!userIsEmpty('user')" class="messages container-mobile">
        <div class="messages-wrapper">
            <div class="messages-aside">
                <audio id="message-sound" class="hidden-audio" preload="auto">
                    <source
                        src="@/assets/sounds/message.m4a"
                        type="audio/mp4"
                    />
                </audio>
                <div v-if="showThreadsList" class="messages-search">
                    <input
                        type="text"
                        :placeholder="$t('threads.search')"
                        v-model="searchQuery"
                        @input="getSearch()"
                        class="messages-search-input input"
                    />
                </div>
                <div v-if="showThreadsList" class="messages-aside-inner">
                    <div v-bar class="messages-aside-scrollbar-container">
                        <div class="messages-aside-scrollbar-content">
                            <div
                                v-if="threadsLoader"
                                class="threads-wrapper threads-wrapper-loader"
                            >
                                <button class="button-loader"></button>
                            </div>
                            <div
                                v-else-if="search && showSearch"
                                class="threads-wrapper"
                            >
                                <div
                                    v-if="
                                        search.friends.length == 0 &&
                                        search.threads.length == 0 &&
                                        search.messages.length == 0
                                    "
                                    class="messages-empty"
                                >
                                    {{ $t("threads.foundQuery") }}
                                </div>
                                <div v-if="search.threads.length">
                                    <div
                                        v-for="thread in search.threads"
                                        @click="
                                            showThread($event, true, thread)
                                        "
                                        class="user-item threads-item"
                                        :key="thread.id"
                                        :class="{ online: calcOnline(thread) }"
                                    >
                                        <div
                                            v-if="thread.avatar"
                                            :style="{
                                                'background-image':
                                                    'url(' +
                                                    thread.avatar +
                                                    ')',
                                            }"
                                            class="user-item-avatar"
                                        ></div>
                                        <div
                                            v-if="
                                                thread.title && !thread.avatar
                                            "
                                            class="user-item-avatar no-image"
                                        ></div>

                                        <div
                                            v-if="!thread.title"
                                            class="user-item-avatar"
                                        >
                                            <!-- <div
                          v-for="participant in thread.participants"
                          v-if="participant.id != user.id"
                          class="user-item-avatar-inner"
                          :key="participant.id"
                          :style="{
                            'background-image': participant.avatar
                              ? 'url(' + participant.avatar + ')'
                              : '',
                          }"
                          :class="{
                            'no-avatar': !participant.avatar,
                          }"
                        ></div> -->
                                            <!-- <div
                          v-for="participant in filteredParticipantsAvatar"
                          :key="participant.id"
                          class="user-item-avatar-inner"
                          :style="{
                            'background-image': participant.avatar
                              ? 'url(' + participant.avatar + ')'
                              : '',
                          }"
                          :class="{
                            'no-avatar': !participant.avatar,
                          }"
                        ></div> -->
                                        </div>

                                        <div class="user-item-info">
                                            <div
                                                v-if="thread.title"
                                                class="user-item-title"
                                            >
                                                {{ thread.title }}
                                            </div>
                                            <div v-else class="user-item-title">
                                                <span
                                                    v-for="participant in thread.participants"
                                                    :key="participant.id"
                                                >
                                                    <span
                                                        v-if="
                                                            participant.id !=
                                                            user.id
                                                        "
                                                    >
                                                        {{ participant.name }}
                                                    </span>
                                                </span>
                                            </div>
                                            <div
                                                v-if="
                                                    thread.last_message &&
                                                    thread.last_message.text
                                                "
                                                class="user-item-subtitle"
                                            >
                                                <span
                                                    v-if="
                                                        thread.last_message
                                                            .sender.id ==
                                                        user.id
                                                    "
                                                    class="threads-item-my-message"
                                                    >{{ $t("threads.you") }}:
                                                </span>
                                                {{ thread.last_message.text }}
                                            </div>
                                            <div
                                                v-if="
                                                    thread.last_message &&
                                                    thread.last_message.time
                                                "
                                                class="user-item-bottom"
                                            >
                                                {{
                                                    getLastMessageTime(
                                                        thread.last_message
                                                            .time * 1000
                                                    )
                                                }}
                                            </div>
                                            <div
                                                v-else
                                                class="user-item-bottom"
                                            >
                                                {{
                                                    getLastMessageTime(
                                                        thread.created_at * 1000
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <!-- <div
                                            v-if="thread.new_messages_count > 0"
                                            class="threads-item-count"
                                        >
                                            {{
                                                newMessageCount
                                                    ? thread.new_messages_count
                                                    : "9+"
                                            }}
                                        </div> -->
                                    </div>
                                </div>
                                <div v-if="search.friends.length">
                                    <div
                                        v-for="friend in search.friends"
                                        @click="
                                            showThread($event, false, friend)
                                        "
                                        class="user-item threads-item"
                                        :key="friend.id"
                                        :class="{ online: friend.online }"
                                    >
                                        <div
                                            :style="{
                                                'background-image':
                                                    friend.avatar
                                                        ? 'url(' +
                                                          friend.avatar +
                                                          ')'
                                                        : '',
                                            }"
                                            class="user-item-avatar"
                                            :class="{
                                                'no-avatar': !friend.avatar,
                                            }"
                                        ></div>
                                        <div class="user-item-info">
                                            <div class="user-item-title">
                                                {{ friend.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="search.messages.length">
                                    <div
                                        v-for="message in search.messages"
                                        @click="
                                            showThread(
                                                $event,
                                                true,
                                                message.thread,
                                                message
                                            )
                                        "
                                        class="user-item threads-item"
                                        :key="message.id"
                                        :class="{
                                            online: message.sender.online,
                                        }"
                                    >
                                        <div
                                            :style="{
                                                'background-image': message
                                                    .sender.avatar
                                                    ? 'url(' +
                                                      message.sender.avatar +
                                                      ')'
                                                    : '',
                                            }"
                                            class="user-item-avatar"
                                            :class="{
                                                'no-avatar':
                                                    !message.sender.avatar,
                                            }"
                                        ></div>
                                        <div class="user-item-info">
                                            <div class="user-item-title">
                                                {{ message.sender.name }}
                                            </div>
                                            <div
                                                v-if="message.text"
                                                class="user-item-subtitle messages-search-message"
                                            >
                                                <span
                                                    v-if="
                                                        message.sender.id ==
                                                        user.id
                                                    "
                                                    class="threads-item-my-message"
                                                    >{{ $t("threads.you") }}:
                                                </span>
                                                {{ message.text }}
                                            </div>
                                            <div
                                                v-if="message.text"
                                                class="user-item-bottom"
                                            >
                                                {{
                                                    getLastMessageTime(
                                                        message.time * 1000
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="threads-wrapper">
                                <div v-if="!threadsIsEmpty('threads')">
                                    <div
                                        v-for="(thread, index) in threads"
                                        :ref="'thread' + index"
                                        @click="
                                            showThread($event, true, thread)
                                        "
                                        class="user-item threads-item"
                                        :key="thread.id"
                                        :class="{ online: calcOnline(thread) }"
                                    >
                                        <div
                                            v-if="thread.avatar"
                                            :style="{
                                                'background-image':
                                                    'url(' +
                                                    thread.avatar +
                                                    ')',
                                            }"
                                            class="user-item-avatar"
                                        ></div>
                                        <div
                                            v-if="
                                                thread.title && !thread.avatar
                                            "
                                            class="user-item-avatar no-image"
                                        ></div>
                                        <div
                                            v-if="!thread.title"
                                            class="user-item-avatar"
                                        >
                                            <!-- <div
                          v-for="participant in thread.participants"
                          v-if="participant.id != user.id"
                          class="user-item-avatar-inner"
                          :key="participant.id"
                          :style="{
                            'background-image': participant.avatar
                              ? 'url(' + participant.avatar + ')'
                              : '',
                          }"
                          :class="{
                            'no-avatar': !participant.avatar,
                          }"
                        ></div> -->
                                            <!-- <div
                          v-for="participant in filteredParticipantsAvatar"
                          :key="participant.id"
                          class="user-item-avatar-inner"
                          :style="{
                            'background-image': participant.avatar
                              ? 'url(' + participant.avatar + ')'
                              : '',
                          }"
                          :class="{
                            'no-avatar': !participant.avatar,
                          }"
                        ></div> -->
                                            <div
                                                v-if="!thread.title"
                                                class="user-item-avatar"
                                            >
                                                <div
                                                    v-for="participant in thread.participants"
                                                    v-if="
                                                        participant.id !=
                                                        user.id
                                                    "
                                                    class="user-item-avatar-inner"
                                                    :style="{
                                                        'background-image':
                                                            participant.avatar
                                                                ? 'url(' +
                                                                  participant.avatar +
                                                                  ')'
                                                                : '',
                                                    }"
                                                    :class="{
                                                        'no-avatar':
                                                            !participant.avatar,
                                                    }"
                                                ></div>
                                            </div>
                                        </div>
                                        <div class="user-item-info">
                                            <div
                                                v-if="thread.title"
                                                class="user-item-title"
                                            >
                                                {{ thread.title }}
                                            </div>
                                            <div v-else class="user-item-title">
                                                <!-- <span
                            v-for="(participant, i) in thread.participants"
                            v-if="participant.id != user.id"
                            :key="participant.id"
                            >{{ participant.name }}</span
                          > -->
                                                <!-- <span
                            v-for="(
                              participant, index
                            ) in filteredParticipantsUser"
                            :key="index"
                            >{{ participant.name }}</span
                          > -->
                                            </div>
                                            <div
                                                v-if="
                                                    thread.last_message &&
                                                    thread.last_message.text
                                                "
                                                class="user-item-subtitle"
                                            >
                                                <span
                                                    v-if="
                                                        thread.last_message
                                                            .sender.id ==
                                                        user.id
                                                    "
                                                    class="threads-item-my-message"
                                                    >{{ $t("threads.you") }}:
                                                </span>
                                                {{ thread.last_message.text }}
                                            </div>
                                            <div
                                                v-if="
                                                    thread.last_message &&
                                                    thread.last_message.time
                                                "
                                                class="user-item-bottom"
                                            >
                                                {{
                                                    getLastMessageTime(
                                                        thread.last_message
                                                            .time * 1000
                                                    )
                                                }}
                                            </div>
                                            <div
                                                v-else
                                                class="user-item-bottom"
                                            >
                                                {{
                                                    getLastMessageTime(
                                                        thread.created_at * 1000
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <button
                                            @click.stop="
                                                deleteThread(thread.id)
                                            "
                                            class="messages-delete-thread"
                                        ></button>
                                        <!-- <div
                                            v-if="thread.new_messages_count > 0"
                                            class="threads-item-count"
                                        >
                                            {{
                                                newMessageCount
                                                    ? thread.new_messages_count
                                                    : "9+"
                                            }}
                                        </div> -->
                                    </div>
                                </div>
                                <div v-else class="messages-empty">
                                    {{ $t("threads.conversationsEmpty") }}
                                </div>
                                <div v-if="moreLoader">
                                    <button class="button-loader"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <form
                    v-if="showCreateThread"
                    data-vv-scope="createStep1Form"
                    @submit.prevent="createThreadStep1('createStep1Form')"
                    class="messages-create-thread"
                >
                    <input
                        type="text"
                        placeholder="Название чата"
                        v-model="title"
                        name="title"
                        v-validate.persist="'required'"
                        class="messages-title-input input"
                        :maxlength="100"
                    />
                    <div class="v-error">
                        {{ errors.first("createStep1Form.title") }}
                    </div>

                    <div class="messages-avatar">
                        <label for="avatar" class="messages-avatar-label">
                            {{ $t("threads.chatAvatar") }} :</label
                        >
                        <input
                            type="file"
                            accept="image/*"
                            id="avatar"
                            name="avatar"
                            @change="addImage($event, 'avatar')"
                            v-validate.persist="
                                'size:10000|ext:jpeg,jpg,png,gif'
                            "
                            data-vv-as="file"
                            class="input-hidden"
                        />
                        <div class="messages-avatar-row">
                            <div
                                :style="{
                                    'background-image':
                                        avatar &&
                                        !errors.has('createStep1Form.avatar')
                                            ? 'url(' + avatar + ')'
                                            : '',
                                }"
                                class="messages-avatar-preview"
                                :class="{
                                    'no-image':
                                        !avatar ||
                                        errors.has('createStep1Form.avatar'),
                                }"
                            >
                                <div
                                    class="messages-delete-image"
                                    @click="deleteImage('avatar')"
                                    v-if="
                                        avatar &&
                                        !errors.has('createStep1Form.avatar')
                                    "
                                ></div>
                            </div>
                            <label
                                for="avatar"
                                class="messages-avatar-button button-secondary"
                            >
                                {{ $t("threads.selectFile") }}</label
                            >
                        </div>
                        <div class="v-error">
                            {{ errors.first("createStep1Form.avatar") }}
                        </div>
                    </div>
                    <div class="messages-create-buttons">
                        <button
                            type="submit"
                            class="button messages-create-button"
                        >
                            {{ $t("threads.save") }}
                        </button>
                        <button
                            @click="cancelCreateThread"
                            type="button"
                            class="button-secondary messages-create-button"
                        >
                            {{ $t("threads.cancel") }}
                        </button>
                    </div>
                </form>

                <!-- TODO: подумать, что ещё можно вынести в отдельные компоненты -->
                <ThreadParticipants
                    v-if="showAddUsers"
                    @create-thread-step-2="createThreadStep2"
                    @remove-participant="removeParticipant"
                    @add-participant="addParticipant"
                    @cancel-create-thread="cancelCreateThread"
                    :currentParticipants="currentParticipants"
                    :participantsError="participantsError"
                    :saveLoader="saveLoader"
                ></ThreadParticipants>
            </div>

            <div
                v-if="currentThread"
                class="messages-body info-block"
                :class="{
                    'messages-mobile-hide': mobileHide,
                    'messages-group': currentThread.isGroup,
                }"
            >
                <div class="messages-header">
                    <div @click="hideThread" class="messages-back"></div>
                    <router-link
                        v-if="!currentThread.isGroup && currentThread.avatar"
                        :to="'/profile/' + currentThread.interlocutor.id"
                        :style="{
                            'background-image':
                                'url(' + currentThread.avatar + ')',
                        }"
                        class="messages-header-avatar"
                    ></router-link>
                    <div
                        v-if="currentThread.isGroup && currentThread.avatar"
                        class="messages-header-avatar"
                    ></div>
                    <div
                        v-if="currentThread.isGroup"
                        class="messages-header-inner"
                    >
                        <div class="messages-title">
                            {{ currentThread.title }}
                        </div>
                        <!-- <div
                v-if="currentThread.participantsCount"
                class="messages-header-participants"
              >
                {{ currentThread.participantsCount }}
                {{
                  declineNouns(currentThread.participantsCount, [
                    $t("threads.participant"),
                    $t("threads.participants"),
                    $t("threads.participantsMore"),
                  ])
                }}
              </div> -->
                    </div>
                    <div v-else class="messages-header-inner">
                        <router-link
                            :to="'/profile/' + currentThread.interlocutor.id"
                            class="messages-title"
                            >{{ currentThread.title }}</router-link
                        >
                        <div
                            v-if="currentThread.interlocutor.online"
                            class="messages-online"
                        >
                            online
                        </div>
                        <div
                            v-else
                            class="messages-online messages-last-online"
                        >
                            {{ $t("threads.was")
                            }}<span
                                v-if="currentThread.interlocutor.gender == 2"
                                >{{ $t("threads.a") }}</span
                            >
                            {{
                                getShortDMY(
                                    currentThread.interlocutor.last_online *
                                        1000
                                )
                            }}
                            {{ $t("threads.in") }}
                            {{
                                getHM(
                                    currentThread.interlocutor.last_online *
                                        1000
                                )
                            }}
                        </div>
                    </div>

                    <div
                        v-if="currentThread.actions"
                        ref="contextButton"
                        @click="showChatContext = !showChatContext"
                        class="messages-context-opener"
                    ></div>
                    <div
                        v-if="currentThread.actions && showChatContext"
                        v-click-outside="{
                            exclude: ['contextButton'],
                            handler: 'clickOutsideContext',
                        }"
                        class="messages-context"
                    >
                        <div
                            v-if="currentThread.isGroup"
                            @click="editGroupChat"
                            class="messages-context-item"
                        >
                            {{ $t("threads.editChat") }}
                        </div>
                        <!-- <div
                v-if="currentThread.isGroup"
                @click="editGroupParticipants"
                class="messages-context-item"
              >
                {{ $t("threads.addDeleteParticipants") }}
              </div> -->
                        <div
                            v-if="!currentThread.isGroup"
                            @click="showCreateThreadForm"
                            class="messages-context-item"
                        >
                            {{ $t("threads.createCollectiveChat") }}
                        </div>
                        <div
                            @click="clearThread(currentThread.id)"
                            class="messages-context-item"
                        >
                            {{ $t("threads.clearCorrespondence") }}
                        </div>
                        <!-- {{ currentThread.interlocutor }} -->
                        <div
                            v-if="
                                !currentThread.isGroup &&
                                currentThread.interlocutor.is_blocked.type == 0
                            "
                            @click="
                                handleBlackList(
                                    currentThread.interlocutor.id,
                                    true
                                )
                            "
                            class="messages-context-item"
                        >
                            {{ $t("threads.addBlacklist") }}
                            <span v-if="!user.vip"
                                >({{ $t("threads.vipOnly") }})</span
                            >
                        </div>
                        <div
                            v-if="
                                !currentThread.isGroup &&
                                currentThread.interlocutor.is_blocked.type == 1
                            "
                            @click="
                                handleBlackList(currentThread.interlocutor.id)
                            "
                            class="messages-context-item"
                        >
                            {{ $t("threads.removeBlacklist") }}
                            <span v-if="!user.vip"
                                >({{ $t("threads.vipOnly") }})</span
                            >
                        </div>
                    </div>
                </div>
                <Messages
                    :currentThread="currentThread"
                    :onMessageSent="onMessageSent"
                ></Messages>
            </div>
            <div
                v-else
                class="messages-body info-block"
                :class="{ 'messages-mobile-hide': mobileHide }"
            >
                <div class="messages-empty">
                    {{ $t("threads.hereMessages") }}
                </div>
            </div>
        </div>
    </section>
    <section v-else class="no-auth">
        {{ $t("auth.noAuth") }}
        <router-link class="link" tag="a" :to="{ name: 'home' }">{{
            $t("auth.noAuthLink")
        }}</router-link>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { uploadImage } from "@/mixins/uploadImage";
import { localizeValidation } from "@/mixins/localizeValidation";
import { formatDateTime } from "@/mixins/formatDateTime";
import { declineNouns } from "@/mixins/declineNouns";
import { observeListEnd } from "@/mixins/observeListEnd";
import { scrollToBottom } from "@/mixins/scrollToBottom";
import Messages from "@/components/Blocks/Messages";
import ThreadParticipants from "@/components/Blocks/ThreadParticipants";
import { clickOutside } from "@/directives.js";

export default {
    name: "Threads",
    props: {
        i18n: Object,
    },
    components: {
        Messages,
        ThreadParticipants,
    },
    mixins: [
        formatDateTime,
        uploadImage,
        localizeValidation,
        declineNouns,
        observeListEnd,
        scrollToBottom,
    ],
    data() {
        return {
            threadsLoader: false,
            title: "",
            avatar: "",
            interlocutorId: null,
            currentParticipants: [],
            searchQuery: "",
            participantsError: false,
            showSearch: false,
            showParticipantSearch: false,
            showChatContext: false,
            showThreadsList: true,
            showCreateThread: false,
            showAddUsers: false,
            currentThread: null,
            messageThreadId: null,
            isEdit: false,
            textareaEl: null,
            divEl: null,
            pageLoader: true,
            moreIndex: 0,
            observer: null,
            moreLoader: false,
            mobileHide: true,
            socketWatch: null,
            saveLoader: false,
            searchTimer: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            profile: "profile/fetchProfile",
            userIsEmpty: "user/isEmpty",
            threads: "threads/fetchThreads",
            threadsIsEmpty: "threads/isEmpty",
            threadsErrors: "threads/errors",
            messagesIsEmpty: "messages/isEmpty",
            messages: "messages/fetchMessages",
            nextThreads: "threads/fetchThreadsNext",
            nextMessages: "messages/fetchMessagesNext",
            search: "threads/fetchSearch",
            friends: "friends/fetchFriends",
            friendsNext: "friends/fetchFriendsNext",
            newThread: "threads/fetchNewThread",
            init: "init/fetchInit",
            prevMessages: "messages/fetchMessagesPrev",
        }),
        messageThread() {
            return this.$store.getters["threads/fetchThreadById"](
                parseInt(this.messageThreadId)
            );
        },
        // filteredParticipantsAvatar() {
        //   return this.thread.participants.filter(
        //     (participant) => participant.id !== this.user.id
        //   );
        // },
        // filteredParticipantsUser() {
        //   return this.thread.participants.filter(
        //     (participant) => participant.id != this.user.id
        //   );
        // },
        // newMessageCount() {
        //     thread.new_messages_count < 10;
        // },
    },
    created() {
        this.interlocutorId =
            this.$route.params && this.$route.params.id
                ? this.$route.params.id
                : null;
        this.currentThread = null;
        this.getThreads(true);
        this.localizeValidation();
        this.$validator.localize("ru", {
            custom: {
                participants: {
                    //   required: () => "Выберите хотя бы одного собеседника",
                    required: () => this.$t("threads.chooseInterlocutor"),
                },
            },
        });

        this.socketWatch = this.$store.watch(
            (state, getters) => getters["sockets/message"],
            (msg) => {
                if (msg.event && msg.event === "chat_message") {
                    if (
                        this.currentThread &&
                        msg.data.thread.id == this.currentThread.id &&
                        !this.prevMessages
                    ) {
                        this.$store.dispatch("messages/addFromFront", msg.data);
                        let self = this;
                        setTimeout(function () {
                            self.scrollToBottom();
                        }, 200);
                        this.$store.dispatch("threads/setNewMessages", {
                            id: msg.data.thread.id,
                            text: msg.data.text,
                            senderId: msg.data.sender.id,
                        });
                    } else {
                        this.$store.dispatch("threads/setNewMessages", {
                            id: msg.data.thread.id,
                            count: 1,
                            increment: true,
                            text: msg.data.text,
                            senderId: msg.data.sender.id,
                            thread: msg.data.thread,
                        });
                        this.highlightCurrent();
                    }
                }
            }
        );

        let self = this;
        this.observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting === true) {
                    self.showMoreThreads();
                }
            },
            { threshold: [0] }
        );
        window.addEventListener("resize", this.checkMobile);
    },
    mounted() {},
    beforeDestroy() {
        this.socketWatch();
        window.removeEventListener("resize", this.checkMobile);
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768 ? true : false;
        },
        checkMobile() {
            if (!this.isMobile() && !this.currentThread) {
                this.showThread(null, true, this.threads[0]);
                this.highlightThread(0);
            }
        },
        getThreads(onCreate = false) {
            this.$store
                .dispatch("threads/getThreads")
                .then(() => {
                    this.pageLoader = false;
                    // this.threadsLoader = false;

                    if (this.interlocutorId) {
                        this.$store
                            .dispatch("threads/createThread", {
                                add: false,
                                data: {
                                    participants: [this.interlocutorId],
                                },
                            })
                            .then(() => {
                                this.showThread(null, true, this.newThread);
                                this.highlightCurrent();
                                this.$router.push({ name: "threads" });
                            })
                            .catch(() => {
                                this.$router.push({ name: "threads" });
                                if (!this.threadsIsEmpty("threads")) {
                                    this.showThread(
                                        null,
                                        true,
                                        this.threads[0]
                                    );
                                    this.highlightThread(0);
                                }
                            });
                    } else if (
                        !this.threadsIsEmpty("threads") &&
                        onCreate &&
                        !this.isMobile()
                    ) {
                        this.showThread(null, true, this.threads[0]);
                        this.highlightThread(0);
                    }

                    this.updateMoreIndex();
                    this.observeListEnd("thread");
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        decrementCounter(count) {
            if (this.init.counters.messages == 0) {
                return;
            }
            this.$store.dispatch("init/setCounters", {
                counter: "messages",
                increment: true,
                count: -1 * count,
            });
        },
        showCreateThreadForm() {
            this.mobileHide = true;
            this.showChatContext = false;
            this.showThreadsList = false;
            this.showCreateThread = true;
        },
        cancelCreateThread() {
            this.mobileHide = false;
            this.showThreadsList = true;
            this.showCreateThread = false;
            this.showAddUsers = false;
            this.title = "";
            this.avatar = "";
            this.errors.clear();
            this.$validator.reset();
            this.isEdit = false;
            this.highlightCurrent();
        },
        createThreadStep1(scope) {
            this.$validator.validateAll(scope).then((valid) => {
                if (valid) {
                    if (this.isEdit) {
                        const data = {};
                        data.title = this.title;
                        if (this.avatar != this.currentThread.avatar) {
                            data.avatar = this.avatar;
                        }
                        if (Object.keys(data).length) {
                            data.participants = [];
                            for (let i in this.currentThread.participants) {
                                data.participants.push(
                                    this.currentThread.participants[i].id
                                );
                            }
                            this.$store
                                .dispatch("threads/editThread", {
                                    id: this.currentThread.id,
                                    data: data,
                                })
                                .then(() => {
                                    this.showCreateThread = false;
                                    this.showThreadsList = true;
                                    this.currentThread.title = this.title;
                                    this.title = "";
                                    this.currentThread.avatar = this.avatar;
                                    this.avatar = "";
                                    this.errors.clear();
                                    this.$validator.reset();
                                    this.isEdit = false;
                                    this.highlightCurrent();
                                })
                                .catch(() => {
                                    if (
                                        typeof this.threadsErrors === "object"
                                    ) {
                                        for (let key in this.threadsErrors) {
                                            this.errors.add({
                                                field: scope + "." + key,
                                                msg: this.threadsErrors[key][0],
                                            });
                                        }
                                    }
                                });
                        } else {
                            this.showCreateThread = false;
                            this.showThreadsList = true;
                            this.title = "";
                            this.avatar = "";
                            this.isEdit = false;
                            this.highlightCurrent();
                        }
                    } else {
                        this.showCreateThread = false;
                        this.currentParticipants = [];
                        for (let i in this.currentThread.participants) {
                            this.currentParticipants.push(
                                this.currentThread.participants[i]
                            );
                        }
                        this.showAddUsers = true;
                    }
                }
            });
        },
        createThreadStep2() {
            if (this.currentParticipants.length < 3) {
                this.participantsError = true;
                return;
            }
            this.saveLoader = true;
            const data = {};
            data.participants = [];
            for (let i in this.currentParticipants) {
                data.participants.push(this.currentParticipants[i].id);
            }
            let action, payload;
            if (this.isEdit) {
                data.title = this.currentThread.title;
                payload = { id: this.currentThread.id, data: data };
                action = "threads/editThread";
            } else {
                data.title = this.title;
                if (this.avatar) {
                    data.avatar = this.avatar;
                }
                action = "threads/createThread";
                payload = { add: true, data: data };
            }

            this.$store
                .dispatch(action, payload)
                .then(() => {
                    this.saveLoader = false;
                    this.title = "";
                    this.avatar = "";
                    this.errors.clear();
                    this.$validator.reset();
                    this.showAddUsers = false;
                    this.showThreadsList = true;
                    if (this.isEdit) {
                        this.currentThread.participants = [];
                        for (let i in this.currentParticipants) {
                            this.currentThread.participants.push(
                                this.currentParticipants[i]
                            );
                            this.currentThread.participantsCount =
                                this.currentParticipants.length;
                        }
                        this.highlightCurrent();
                    } else {
                        this.showThread(null, true, this.threads[0]);
                    }
                    this.mobileHide = false;
                    this.isEdit = false;
                })
                .catch(() => {
                    this.saveLoader = false;
                    if (typeof this.threadsErrors === "object") {
                        this.$modal.show("dialog", {
                            title: this.$t("threads.mistake"),
                            text: generateErrList(this.threadsErrors),
                            buttons: [
                                {
                                    title: this.$t("roulette.ok"),
                                },
                            ],
                        });

                        function generateErrList(obj) {
                            let list = "<ul>";
                            for (let key in obj) {
                                list = list.concat("<li>", obj[key], "</li>");
                            }
                            list = list.concat("</ul>");
                            return list;
                        }
                    }
                    // this.isEdit = false;
                });
        },
        deleteThread(id) {
            this.$modal.show("dialog", {
                title: this.$t("threads.warning"),
                text: this.$t("threads.conversationDeleted"),
                buttons: [
                    {
                        title: this.$t("threads.delete"),
                        handler: () => {
                            this.$store
                                .dispatch("threads/deleteThread", id)
                                .then(() => {
                                    if (this.currentThread.id == id) {
                                        this.showThread(
                                            null,
                                            true,
                                            this.threads[0]
                                        );
                                        this.highlightCurrent();
                                    }
                                    this.$modal.hide("dialog");
                                })
                                .catch(() => {
                                    this.$modal.hide("dialog");
                                });
                        },
                    },
                    {
                        title: this.$t("threads.cancel"),
                    },
                ],
            });
        },
        getSearch() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                if (this.searchQuery && this.searchQuery.length > 2) {
                    this.threadsLoader = true;
                    this.$store
                        .dispatch(
                            "threads/search",
                            encodeURIComponent(this.searchQuery)
                        )
                        .then(() => {
                            this.threadsLoader = false;
                            this.showSearch = true;
                            this.removeHighlight();
                        })
                        .catch(() => {
                            this.threadsLoader = false;
                            this.showSearch = true;
                        });
                } else {
                    this.showSearch = false;
                    this.highlightCurrent();
                }
            }, 500);
        },
        updateMoreIndex() {
            this.moreIndex = this.threads.length - 2;
        },
        showMoreThreads() {
            if (this.nextThreads) {
                this.moreLoader = true;
                this.$store
                    .dispatch("threads/getNext")
                    .then(() => {
                        this.observeListEnd("thread", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("thread", false, true);
            }
        },
        highlightCurrent() {
            if (!this.currentThread) {
                return;
            }
            setTimeout(() => {
                this.highlightThread(
                    this.getThreadIndex(this.currentThread.id)
                );
            }, 200);
        },
        highlightThread(index) {
            setTimeout(() => {
                let elems = document.querySelectorAll(".threads-item");
                [].forEach.call(elems, function (el, i) {
                    el.classList.remove("thread-current");
                    if (index == i) {
                        el.classList.add("thread-current");
                    }
                });
            }, 50);
        },
        removeHighlight() {
            let elems = document.querySelectorAll(".thread-current");
            [].forEach.call(elems, function (el) {
                el.classList.remove("thread-current");
            });
        },
        showThread(event, threadExists = false, obj, message = false) {
            this.showChatContext = false;
            this.mobileHide = false;
            if (event) {
                this.removeHighlight();
                event.currentTarget.classList.add("thread-current");
            }
            this.currentThread = {};
            this.currentThread.participants = [];
            if (threadExists) {
                this.$store.dispatch("messages/setActiveThread", obj.id);
                this.currentThread.id = obj.id;
                this.currentThread.actions = true;
                this.currentThread.messages = true;
                if (message) {
                    this.currentThread.message = message;
                }
                if (obj.title) {
                    this.currentThread.isGroup = true;
                    this.currentThread.title = obj.title;
                    if (obj.avatar) {
                        this.currentThread.avatar = obj.avatar;
                    }
                    this.currentThread.participantsCount =
                        obj.participants.length;
                    let count = this.currentThread.participantsCount.toString();
                } else {
                    for (let i in obj.participants) {
                        if (obj.participants[i].id != this.user.id) {
                            this.currentThread.title = obj.participants[i].name;
                            this.currentThread.interlocutor =
                                obj.participants[i];
                            this.currentThread.avatar =
                                obj.participants[i].avatar || null;
                            let interlocutor = obj.participants[i];
                            this.currentThread.vip =
                                interlocutor.vip_settings.messages == 1 &&
                                interlocutor.is_friend.type != 2 &&
                                !this.user.vip;
                            this.currentThread.blacklist =
                                interlocutor.i_am_blocked;
                        }
                    }
                }
                for (let j in obj.participants) {
                    this.currentThread.participants.push(obj.participants[j]);
                }
            } else {
                this.currentThread.interlocutor = obj;
                this.currentThread.title = obj.name;
                this.currentThread.participants.push({
                    id: this.user.id,
                    name: this.user.name,
                    avatar: this.user.avatar,
                });
                this.currentThread.participants.push({
                    id: obj.id,
                    name: obj.name,
                    avatar: obj.avatar,
                });
                this.$store.dispatch("messages/getEmptyMessages");
            }
        },
        hideThread() {
            this.currentThread = null;
            this.mobileHide = true;
            this.$store.dispatch("messages/getEmptyMessages");
            this.removeHighlight();
        },
        clearThread(id) {
            this.$modal.show("dialog", {
                text: this.$t("threads.clearCorrespondence"),
                buttons: [
                    {
                        title: this.$t("threads.clear"),
                        handler: () => {
                            this.$store
                                .dispatch("messages/clearMessages", id)
                                .then(() => {
                                    this.$modal.hide("dialog");
                                    this.showChatContext = false;
                                })
                                .catch(() => {
                                    this.$modal.hide("dialog");
                                    this.showChatContext = false;
                                });
                        },
                    },
                    {
                        title: this.$t("threads.cancel"),
                    },
                ],
            });
        },
        onMessageSent() {
            this.getThreads();
        },
        showMoreMessages() {
            this.$store.dispatch("messages/getNext");
        },
        handleBlackList(id, add = false) {
            if (!this.user.vip) {
                return;
            }
            let action, success;
            if (add) {
                action = "profile/addToBlacklist";
                success = this.$t("threads.userBlock");
            } else {
                action = "blacklist/remove";
                success = this.$t("threads.userBlock");
            }

            this.$store
                .dispatch(action, id)
                .then(() => {
                    this.blacklistLoader = false;
                    this.showContext = false;
                    this.$modal.show("dialog", {
                        title: this.$t("threads.success"),
                        text: success,
                        buttons: [
                            {
                                title: this.$t("roulette.ok"),
                            },
                        ],
                    });
                    this.showChatContext = false;
                    this.currentThread.interlocutor.is_blocked.type = add
                        ? 1
                        : 0;
                })
                .catch(() => {
                    this.showChatContext = false;
                });
        },
        getThreadIndex(id) {
            let pos = this.threads
                .map(function (e) {
                    return e.id;
                })
                .indexOf(id);
            return pos;
        },
        addParticipant(obj) {
            this.currentParticipants.push({
                id: obj.id,
                name: obj.name,
                avatar: obj.avatar,
            });
            if (this.currentParticipants.length >= 3) {
                this.participantsError = false;
            }
        },
        removeParticipant(id) {
            let pos = this.currentParticipants
                .map(function (e) {
                    return e.id;
                })
                .indexOf(id);
            this.currentParticipants.splice(pos, 1);
        },
        editGroupChat() {
            this.mobileHide = true;
            this.showChatContext = false;
            this.showThreadsList = false;
            this.showAddUsers = false;
            this.showCreateThread = true;
            this.isEdit = true;
            this.title = this.currentThread.title;
            if (this.currentThread.avatar) {
                this.avatar = this.currentThread.avatar;
            }
        },
        editGroupParticipants() {
            this.mobileHide = true;
            this.showChatContext = false;
            this.showThreadsList = false;
            this.showCreateThread = false;
            this.currentParticipants = [];
            for (let i in this.currentThread.participants) {
                this.currentParticipants.push(
                    this.currentThread.participants[i]
                );
            }
            this.showAddUsers = true;
            this.isEdit = true;
        },
        clickOutsideContext() {
            this.showChatContext = false;
        },
        calcOnline(obj) {
            if (obj.avatar || obj.title) {
                return false;
            }
            for (let i in obj.participants) {
                if (
                    obj.participants[i].id != this.user.id &&
                    obj.participants[i].online
                ) {
                    return true;
                }
            }
            return false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
</style>

<style lang="scss">
@import "~@/assets/styles/pages/_messages";
</style>
